<script lang="ts">
  import type { Snippet } from 'svelte'
  import AppHeader from '../components/AppHeader.svelte'
  import AppSidebar from '../components/AppSidebar.svelte'
  import ApiErrorBanner from '../components/ApiErrorBanner.svelte'
  import Toaster from '../components/Toaster.svelte'
  import UnsavedChangesModal from '../components/UnsavedChangesModal.svelte'

  interface Props {
    children?: Snippet
  }

  let { children }: Props = $props()
</script>

<div class="shell">
  <AppSidebar />
  <div class="shell__main">
    <AppHeader />
    <ApiErrorBanner />
    <main class="shell__content">
      {@render children?.()}
    </main>
  </div>
  <Toaster />
  <UnsavedChangesModal />
</div>

<style lang="scss">
  @use '../assets/styles/variables' as v;

  .shell {
    display: flex;
    min-height: 100vh;
    background: v.$color-bg;
  }

  .shell__main {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .shell__content {
    flex: 1;
    padding: v.$space-xl v.$space-xl v.$space-2xl;
    max-width: 1400px;
    width: 100%;
    margin: 0 auto;
  }

  @media (max-width: v.$bp-md) {
    .shell__content {
      padding: v.$space-md;
    }
  }
</style>
